import { useNavigate } from "react-router";
import { useState, useEffect, useRef } from "react";

export default function Presentation() {
  const navigate = useNavigate();
  const [titleSize, setTitleSize] = useState("32px");
  const [subtitleSize, setSubtitleSize] = useState("11px");

  const wrapperRef = useRef<HTMLDivElement>(null);
  const [videoSize, setVideoSize] = useState<{ w: number; h: number }>({ w: 0, h: 0 });

  const handleNavigateToAbout = () => {
    navigate("/ourFood");
  };

  // Ajuste de tipografías
  useEffect(() => {
    const updateFontSize = () => {
      const width = window.innerWidth;
      if (width < 350) {
        setTitleSize("30px");
        setSubtitleSize("15px");
      } else if (width < 480) {
        setTitleSize("38px");
        setSubtitleSize("19px");
      } else if (width < 768) {
        setTitleSize("44px");
        setSubtitleSize("21px");
      } else if (width < 1024) {
        setTitleSize("54px");
        setSubtitleSize("25px");
      } else {
        setTitleSize("70px");
        setSubtitleSize("29px");
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);
    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  // 🚫 Sin overflow + cover 16:9 con cálculo dinámico
  useEffect(() => {
    const R = 16 / 9;

    const updateVideoCover = () => {
      const el = wrapperRef.current;
      if (!el) return;
      const { width, height } = el.getBoundingClientRect();
      if (!width || !height) return;

      const containerRatio = width / height;
      let w: number, h: number;

      if (containerRatio >= R) {
        // Contenedor más ancho: llenar por ancho
        w = width;
        h = width / R;
      } else {
        // Contenedor más alto: llenar por alto
        h = height;
        w = height * R;
      }
      setVideoSize({ w, h });
    };

    updateVideoCover();
    const onResize = () => updateVideoCover();
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className="relative flex flex-col items-center justify-center h-[400px] sm:h-[500px] md:h-[683px] z-20 px-4 sm:px-6 md:px-8 overflow-hidden pt-20"
    >
      {/* 🎥 Video de fondo centrado y con 'cover' sin generar scroll */}
      <div className="absolute inset-0 -z-10 pointer-events-none overflow-hidden">
        <iframe
          className="absolute"
          style={{
            width: `${videoSize.w}px`,
            height: `${videoSize.h}px`,
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
          src="https://www.youtube.com/embed/a_0AgvcCQ20?autoplay=1&mute=1&loop=1&playlist=a_0AgvcCQ20&controls=0&modestbranding=1&showinfo=0&start=341&end=400"
          title="Vegan Vegetarian Background Video"
          allow="autoplay; fullscreen; encrypted-media"
          referrerPolicy="strict-origin-when-cross-origin"
        />
        {/* Overlay para contraste */}
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {/* Contenido */}
      <div className="relative z-10 flex flex-col items-center">
        <div
          style={{ fontSize: titleSize }}
          className="text-white text-center  tracking-wider  leading-tight whitespace-nowrap text-6xl"
        >
          Vegan Vegetarian
        </div>

        <div
          style={{ fontSize: subtitleSize }}
          className="pt-5 text-white text-justify font-light tracking-wider leading-tight w-3/4"
        >
          En Vegan Vegetarian somos más que una marca: somos el reflejo de una vida dedicada a la pasión, la disciplina y el amor por la alimentación consciente. Nuestra Historia comenzó con Karla Y Pedro con más de 30 años de experiencia en la comida vegetariana En este viaje fuimos creando recetas propias, llenas de creatividad y autenticidad, que hoy son el corazón de Vegan Vegetarian.
        </div>

        <button
          onClick={handleNavigateToAbout}
          className="hover:cursor-pointer mt-10 bg-white p-5 rounded-2xl text-[#275823] font-bold text-3xl border-2 border-[#C5A537]"
        >
          Nuestros productos
        </button>
      </div>
    </div>
  );
}
